module.exports = __webpack_public_path__ + "80fbb44771c3c53348e8a36f2ae318ba.png";